
















import { Component, Prop, Vue } from 'vue-property-decorator';
@Component({
    name: 'CommoditySkeletonList',
    components: {}
})
export default class CommoditySkeletonList extends Vue {
    @Prop({
        type: Boolean,
        default: false
    })
    public loading: boolean;
}
